import { useParams } from "react-router-dom";

export function useCode(): string {
  const { code } = useParams<{ code: string }>();

  if (!code) {
    throw new Error("Shop code is does not exist in the path.")
  }

  return code;
}
